function normalize(obj) {
  const o = { ...obj };
  delete o.visualizer;

  if (Array.isArray(o.selected_questions)) {
    o.selected_questions = o.selected_questions
      .filter((q) => q.selected_items?.length > 0)
      .map((q) => ({
        id: q.id,
        selected_item_ids: q.selected_items.map((si) => si.id).sort(),
      }))
      .sort((a, b) => (a.id > b.id ? 1 : -1));
  }

  return o;
}

export default function qbHasChanged(qd, rqd) {
  if (!rqd) return false;
  return JSON.stringify(normalize(rqd)) !== JSON.stringify(normalize(qd));
}
